/**
 * This file is part of an epic that is currently on hold and is not being used in the application.
 * Please refer to the README.md file in the root of the PDFRenderer directory for more information.
 */
import { Font } from "@react-pdf/renderer";

// font source: https://fonts.google.com/noto/specimen/Noto+Sans+SC
// this font is being use because it supports Chinese characters
// in a perfect world, we would be able to use our standard "Source Sans Pro" font
// and use this as a fallback, but react-pdf does not support font fallback at the moment.
// 03/19/2024
import notoSansBlack from "./ttf/noto_sans_black.ttf";
import notoSansBold from "./ttf/noto_sans_bold.ttf";
import notoSansExtralight from "./ttf/noto_sans_extralight.ttf";
import notoSansLight from "./ttf/noto_sans_light.ttf";
import notoSansMedium from "./ttf/noto_sans_medium.ttf";
import notoSansRegular from "./ttf/noto_sans_regular.ttf";
import notoSansSemibold from "./ttf/noto_sans_semibold.ttf";

Font.register({
	family: "Noto Sans",
	fontWeight: "heavy",
	src: notoSansBlack,
});

Font.register({
	family: "Noto Sans",
	fontWeight: "bold",
	src: notoSansBold,
});

Font.register({
	family: "Noto Sans",
	fontWeight: "ultralight",
	src: notoSansExtralight,
});

Font.register({
	family: "Noto Sans",
	src: notoSansRegular,
});

Font.register({
	family: "Noto Sans",
	fontWeight: "light",
	src: notoSansLight,
});

Font.register({
	family: "Noto Sans",
	fontWeight: "medium",
	src: notoSansMedium,
});

Font.register({
	family: "Noto Sans",
	fontWeight: "normal",
	src: notoSansRegular,
});

Font.register({
	family: "Noto Sans",
	fontWeight: "semibold",
	src: notoSansSemibold,
});
